import Fingerprint2 from "fingerprintjs2";

/**
 * Comparing objects/array with user-defined compare function
 *
 * @param a
 * @param b
 * @param compareFunc
 * @return {{added: Array, removed: Array}}
 */
export function udiff(a, b, compareFunc) {
    let indexB, indexA, presentInA, presentInB, aVal, bVal;

    let added = [], removed = [];

    for (indexB in b) {
        bVal = b[indexB];
        presentInA = false;
        for (indexA in a) {
            aVal = a[indexA];
            if (compareFunc(aVal, bVal)) {
              presentInA = true;
              break;
            }
        }
        if (!presentInA) added.push(bVal);
    }

    for (indexA in a) {
        aVal = a[indexA];
        presentInB = false;
        for (indexB in b) {
            bVal = b[indexB];
            if (compareFunc(aVal, bVal)) {
              presentInB = true;
              break;
            }
        }
        if (!presentInB) removed.push(aVal);
    }

    return {added, removed};
}

export function formatURL(url, data) {
    let newUrl = url;

    for (let name in data) {
        let value = data[name];
        newUrl = newUrl.replace('{'+ name+ '}', encodeURIComponent(value));
    }

    return newUrl;
}

export function buildURL(url, params) {
    if (typeof params === 'string' && params[0] === '?') {
        return url + params;
    }

    let searchArr = [];
    for (let name in params) {
        let value = params[name];
        searchArr.push(encodeURIComponent(name) + '=' + encodeURIComponent(value));
    }

    return url + (searchArr.length ? '?' + searchArr.join('&') : '');
}

export function getBaseDomain(url) {
    var oUrl = new URL(url);
    var hostName = oUrl.hostname;
    var domain = hostName;

    if (hostName != null) {
        var parts = hostName.split('.').reverse();

        if (parts != null && parts.length > 1) {
            domain = parts[1] + '.' + parts[0];
        }
    }

    return domain;
}

export function uniqueId() {
    var S4 = function() {
       return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    };
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}

export function setCookie(name, value, expirationDate) {
    let expires = "";

    if (expirationDate) {
        expires = "; expires=" + expirationDate.toGMTString();
    }

    document.cookie = name + "=" + value + expires + "; path=/";
}

export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1,c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length,c.length);
        }
    }

    return null;
}



export const fingerPrintOptions = {
    excludes: {
        //userAgent: true, //?
        language: true,
        hasLiedLanguages: true,
        availableScreenResolution: true,
        pixelRatio: true,
        colorDepth: true,
        fonts: true,
        fontsFlash: true,
        timezoneOffset: true,
        timezone: true,
        cpuClass: true,
        //canvas: true,
        webgl: true,
        adBlock: true,
        audio: true,
        sessionStorage: true,
        localStorage: true,
        indexedDb: true,
        addBehavior: true,
        openDatabase: true,
        doNotTrack: true,
        //plugins: true,
        deviceMemory: true,
        webdriver: true,
        //webglVendorAndRenderer: true, //?
        enumerateDevices: true, //?
    },
};


export function getFingerprint() {

    Fingerprint2.get(fingerPrintOptions, function (components) {
        // console.log(components); // an array of components: {key: ..., value: ...}
        let values = components.map(component => component.value);
        let fingerprint = Fingerprint2.x64hash128(values.join(''), 31);

        let dt = new Date();
        dt.setFullYear(dt.getFullYear() + 10);
        window.fingerprint = fingerprint + "." + dt.getTime();
        console.log("fingerprint", window.fingerprint);

        setCookie("BOBSID", window.fingerprint, dt);
    });

}




// WEBPACK FOOTER //
// ./src/utils.js